import {
  Avatar,
  Box,
  Container,
  Flex,
  Grid,
  Image,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { motion } from "framer-motion";

  const array = [
    {
      id: 1,
      src: "https://cdn1.iconfinder.com/data/icons/logotypes/32/badge-html-5-128.png",

      title: "HTML",
      style: "shadow-orange-500",
    },
    {
      id: 2,
      src: "https://cdn1.iconfinder.com/data/icons/logotypes/32/badge-css-3-128.png",

      title: "CSS",
      style: "shadow-blue-500",
    },
    {
      id: 3,
      src: "https://i.ibb.co/jZMcZMC/javascript.png",

      title: "JavaScript",
      style: "shadow-yellow-500",
    },
    {
      id: 4,
      src: "https://codexpuneet.github.io/static/media/react.0cf951a69d8e58f83f9d.png",
      title: "React",
      style: "shadow-blue-600",
    },
    {
      id: 5,
      src: "https://codexpuneet.github.io/static/media/redux.1b4bb5fceb01b19da59d.png",
      title: "Redux",
      style: "shadow-violet-400",
    },

    {
      id: 6,
      src: "https://codexpuneet.github.io/static/media/chakra.36db97903e01c1040ed5.png",
      title: "ChakraUI",
      style: "shadow-cyan-400",
    },
    {
      id: 7,
      src: "https://codexpuneet.github.io/static/media/tailwind.e47ac876b8d4d0bba47a.png",
      title: "Tailwind",
      style: "shadow-sky-400",
    },
    // {
    //   id: 8,
    //   src: TS,
    //   title: "TypeScript",
    //   style: "shadow-blue-400",
    // },
    // {
    //   id: 9,
    //   src: cy,
    //   title: "Cypress Testing",
    //   style: "shadow-gray-400",
    // },
    {
      id: 10,
      src: "https://i.ibb.co/dMhVT7t/mongodb.png",
      title: "MongoDB",
      style: "shadow-green-500",
    },
    {
      id: 11,
      src: "https://codexpuneet.github.io/static/media/node.952a9ea986dcfa5229ad.png",
      title: "NodeJS",
      style: "shadow-green-300",
    },
    {
      id: 12,
      src: "https://codexpuneet.github.io/static/media/express.cca64e0f360897258ecb.png",
      title: "ExpressJS",
      style: "shadow-gray-600",
    },
    {
      id: 13,
      src: "https://cdn3.iconfinder.com/data/icons/social-media-2169/24/social_media_social_media_logo_github-128.png",
      title: "GitHub",
      style: "shadow-gray-400",
    },
    {
      id: 14,
      src: "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/postman-icon.png",
      title: "Postman",
      style: "shadow-orange-600",
    },
    // {
    //   id: 15,
    //   src: "https://codexpuneet.github.io/static/media/api.30c0a28eb0caa589d37d.jpeg",
    //   title: "API",
    //   style: "shadow-green-600",
    // },
    // {
    //   id: 16,
    //   src: "",
    //   title: "npm",
    //   style: "shadow-orange-400",
    // },
  ];
function Skills() {
  let mode = localStorage.getItem("chakra-ui-color-mode");

  return (
    <Box id="skills" pt="8">
      <br />
      <br />
      <br />
      <Flex w="full" justifyContent={"center"}>
        <Text
          color="orange.500"
          fontSize="22px"
          letterSpacing="20px"
          fontWeight="700"
        >
          SKILLS
        </Text>
      </Flex>
      <br />
      <br />
      <Flex justifyContent={"center"} alignItems="center">
        <Grid
          m="auto"
          w="26%"
          alignItems={"center"}
          justifyContent="center"
          gridTemplateColumns="repeat(4,1fr)"
          rowGap="10"
          columnGap={{ base: "3", md: "0" }}
        >
          {array.map(({ id, style, title, src }) => {
            return (
              <>
                <motion.div
                  initial={{ scale: 0 }}
                  whileInView={{ rotate: 360, scale: 1 }}
                  transition={{
                    type: "spring",
                    stiffness: 260,
                    damping: 60,
                  }}
                >
                  <Flex
                    className="skills-card"
                    justifyContent="center"
                    alignItems="center"
                    flexDir={"column"}
                    gap={"3"}
                  >
                    <Flex
                      justifyContent="center"
                      alignItems="center"
                      border="1px solid gray"
                      borderRadius="full"
                      overflow={"hidden"}
                      flexDir={"column"}
                      p="3"
                      w="75px"
                      key={id}
                      className={`shadow-md hover:scale-105 duration-50 py-2 rounded-full ${style}`}
                    >
                      <Image className="skills-card-img" w="100%" src={src} />
                    </Flex>
                    <p
                      className="skills-card-name"
                    
                      // className="text-xs"
                      style={
                        mode == "dark" ? { color: "white" } : { color: "black" }
                      }
                    >
                      {title}
                    </p>
                  </Flex>
                </motion.div>
              </>
            );
          })}
        </Grid>
      </Flex>
    </Box>
  );
}

export default Skills;
